import {useMemo} from 'react';

import {useAppSelector} from 'hooks';
import {BasketLineItem, PreviewBasketItemV5, Product, ProductSearchResult} from 'types';
import {findBasketItem} from 'utils';

type CurrentBasketItemResult = {
  basketItem: BasketLineItem | PreviewBasketItemV5 | undefined;
  productCount: number;
};

export const useCurrentBasketItem = (product: Product | ProductSearchResult): CurrentBasketItemResult => {
  const basket = useAppSelector((state) => state?.basket.basket);

  const basketItem: BasketLineItem | PreviewBasketItemV5 | undefined = useMemo(
    () => findBasketItem(product, [...(basket?.basketItems || []), ...(basket?.unavailableItems || [])]),
    [product, basket?.basketItems, basket?.unavailableItems]
  );

  return {
    basketItem: basketItem,
    productCount: basketItem?.quantity || 0
  };
};
